import classes from "./ActivityEditor.module.css";
import settingClasses from "../PlatformSetting/Settings.module.css";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {
    ACTIVITY_EDITOR_VIEW,
    CHOOSE_GRADE_SCHEMA_ASKING,
    EDITING_GRADING_OPTION_GRADED_TO_UNGRADED_CONTENT,
    EDITING_GRADING_OPTION_TEXT,
    GRADE_SCHEMA,
    MODAL_CANCEL_TEXT,
    MODAL_CONFIRM_TEXT,
    POLL_TYPE,
    SYNC_LMS_OPTIONS,
    USER_SETTINGS,
    EDITING_SYNC_LMS_SYNC_TO_NOT_SYNC_CONTENT,
    AUDIENCE_RESTRICTION,
    COURSE_PLACEHOLDER,
    EDITING_SYNC_LMS_EMBEDDED_BANNER,
    EDITING_SYNC_LMS_EMBEDDED_BANNER_ATTENDANCE,
    EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE,
    CONTINUE_TEXT,
    LMS_TYPE,
    EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE_ATTENDANCE,
    GRADE_BOOK_SYNC_TEXT,
    GRADE_BOOK_SYNC_DESCRIPTION,
    INTEGRATION_TYPES,
    D2L_MODULE_PLACEHOLDER,
    EDITING_GRADING_OPTION_GRADED_TO_UNGRADED_CONTENT_LMS,
    COURSE_FILTER_LABEL,
    MODULE_LABEL,
    CREATE_MODULE,
    CREATE_SECTION, SECTION_HEADER, MOODLE_SECTION_PLACEHOLDER
} from "../../utils/constants";
import {ReactComponent as GRADE_BOOK_ICON} from "../../images/links/active_gradebook_icon.svg";
import {ReactComponent as SPEAKER_ICON} from "../../images/spearker_blue.svg";
import {ReactComponent as STAR_RED_ICON} from "../../images/star_red.svg";
import {ReactComponent as SYNC_IMAGE} from "../../images/activity_editor_graded_icon.svg";
import {ReactComponent as NOT_SYNC_IMAGE} from "../../images/activity_editor_ungraded_icon.svg";
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"


import React, {useEffect, useState} from "react";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import parse from "html-react-parser";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useLocation} from "react-router-dom";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    getActivityAudienceRestriction,
    getDefaultParticipationPoints, getQuestionWeightage,
    isParticipationPointEnabled
} from "../../utils/helpers";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import Skeleton from "react-loading-skeleton";
import CreateD2LModuleModal from "../../components/modals/CreateD2LModuleModal";
import {Button} from "@base-ui/react/button";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import YuJaDialog from "../../components/standardization/YuJaDialog";
import {EVENT_BANNER_LOCATION_TYPES} from "../CSM/EventBannerManagementPage";


export default function ActivityEditorOverview({
                                                   draftActivity,
                                                   setDraftActivity,
                                                   userSettings,
                                                   courseList=[],
                                                   setEditorView,
                                                   hasReleased,
                                                   hasClicked,
                                                   setHasClicked
}) {
    const {pollType, gradeSchema, syncLms, syncLmsOption="", courseId="", D2LModuleId, moodleSectionId} = draftActivity;
    const {isAPISyncOptionAvailable, isLMS, isAlreadyEmbedded, isUnfinishedEmbedded, getDefaultConfiguration, verifyConfiguration, getIntegrationType} = useSynLMSConfiguration(draftActivity);
    const {isPPTPage} = usePPTWebView();

    const integrationType = getIntegrationType();
    const {listD2LModules, listMoodleSections} = LTIApiCalls();





    let location = useLocation();
    const [alertShow, setAlertShow] = useState(false);
    const [syncLmsAlertShow, setSyncLmsAlertShow] = useState(false);
    const [chosenSchema, setChosenSchema] = useState(gradeSchema);
    const [chosenSyncLms, setChosenSyncLms] = useState(syncLms);
    const [moduleDropdownLoading, setModuleDropdownLoading] = useState(false);
    const [createModuleModalShown, setCreateModuleModalShown] = useState(false);
    const [moduleList, setModuleList] = useState([]);

    let isCreatePage = location.pathname.startsWith("/create")
        || (isPPTPage() && location.pathname.endsWith("/create"));

    const loadModulesAndGetDefaultId = async (courseId) => {
        let integrationType = getIntegrationType();
        let apiSyncAvailable = isAPISyncOptionAvailable();

        if ((integrationType !== INTEGRATION_TYPES.D2L && integrationType !== INTEGRATION_TYPES.MOODLE) || !apiSyncAvailable) {
            return undefined;
        }

        if (!courseId) {
            return "-1";
        }

        setModuleDropdownLoading(true);
        try {
            let options = [];
            let propertyName = integrationType === INTEGRATION_TYPES.D2L ? "D2LModuleId" : "moodleSectionId";
            if (integrationType === INTEGRATION_TYPES.D2L) {
                const modules = await listD2LModules(courseId);
                options = modules.map(module => ({
                    value: module.Id,
                    label: module.Title,
                }));
            } else {
                const sections = await listMoodleSections(courseId);
                options = sections.map(section => ({
                    value: section.id,
                    label: section.name,
                }));

            }
            setModuleList(options);


            const copy = JSON.parse(JSON.stringify(draftActivity));
            if (!options.length) {
                return "-1";
            } else {
                if (!!copy[propertyName]) {
                    let option = options.find(opt => opt.value === copy[propertyName]);
                    return !!option ? option.value : options[0].value;
                } else {
                    return options[0].value;
                }
            }
        } finally {
            setModuleDropdownLoading(false);
        }
    }


    const onClickLearnMore = () => {
        window.open(LMS_TYPE[integrationType].embeddingLearnMore, '_blank');
    }


    const redirectEditingView = () => {

        if (pollType === POLL_TYPE.ATTENDANCE) {
            setEditorView(ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
        } else {
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
        }
    }


    const chooseGradeSchema = (schema, e) => {
        if (e.currentTarget.className.includes("disabled")) {
            return;
        }

        if (schema === draftActivity.gradeSchema) {
            return;
        }

        setChosenSchema(schema);
        if (!!gradeSchema && schema === GRADE_SCHEMA.UNGRADED.key) {
            setAlertShow(true);
        } else {
            const copy = JSON.parse(JSON.stringify(draftActivity));
            copy.gradeSchema = schema;

            if (copy.gradeSchema === GRADE_SCHEMA.GRADED.key) {
                const {syncLms, syncLmsOption, courseId, audienceRestriction} = getDefaultConfiguration(courseList.filter(c => !!c.isLmsCourse));
                copy.syncLms = syncLms;
                copy.syncLmsOption = syncLmsOption;
                copy.courseId = courseId;
                copy.audienceRestriction = !!audienceRestriction ? audienceRestriction : copy.audienceRestriction;
            } else {
                copy.syncLms = false;
                delete copy.syncLmsOption;
                delete copy.courseId;
                delete copy.D2LModuleId;
                delete copy.moodleSectionId;
            }


            setDraftActivity(copy);
            if (!isLMS() || schema === GRADE_SCHEMA.UNGRADED.key) {
                redirectEditingView();
            }
        }

    }


    useEffect(() => {
        if (!!draftActivity.courseId) {
            loadModulesAndGetDefaultId(draftActivity.courseId).then((moduleId) => {
                let integrationType = getIntegrationType();
                let propertyName = integrationType === INTEGRATION_TYPES.D2L ? "D2LModuleId" : "moodleSectionId";
                const copy = JSON.parse(JSON.stringify(draftActivity));
                copy[propertyName] = moduleId;
                setDraftActivity(copy);
            });
        }
    }, [draftActivity?.courseId]);


    const chooseSyncGradeBook = (syncLmsVal, e) => {
        if (e.currentTarget.className.includes("disabled")) {
            return;
        }


        if (syncLmsVal === draftActivity.syncLms) {
            return;
        }


        setChosenSyncLms(syncLmsVal);
        if (draftActivity.hasOwnProperty("syncLms") && !syncLmsVal) {
            setSyncLmsAlertShow(true);
        } else {
            const copy = JSON.parse(JSON.stringify(draftActivity));
            copy.syncLms = syncLmsVal;

            if (!!copy.syncLms) {
                copy.audienceRestriction = AUDIENCE_RESTRICTION.REGISTERED;
                const {syncLmsOption, courseId, audienceRestriction} = getDefaultConfiguration(courseList.filter(c => !!c.isLmsCourse));
                copy.syncLmsOption = syncLmsOption;
                copy.courseId = courseId;
                copy.audienceRestriction = !!audienceRestriction ? audienceRestriction : copy.audienceRestriction;
            }
            setDraftActivity(copy);
        }


    }



    const alertConfig = {
        title: EDITING_GRADING_OPTION_TEXT,
        okText: MODAL_CONFIRM_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        submit: () => {
            const copy = JSON.parse(JSON.stringify(draftActivity));
            copy.gradeSchema = chosenSchema;
            if (chosenSchema === GRADE_SCHEMA.GRADED.key) {
                let totalPoints = copy.questions.reduce((sum, q) => sum + getQuestionWeightage(q), 0);
                for (let question of copy.questions) {
                    if (!!question.questionType) {
                        question.weightage =
                            (!totalPoints || !question.hasOwnProperty("weightage"))
                                ? userSettings[USER_SETTINGS.QUESTION_POINTS]
                                : question.weightage;
                        if (isParticipationPointEnabled(userSettings)) {
                            question.participationWeightage =
                                (!totalPoints || !question.hasOwnProperty("participationWeightage"))
                                ? getDefaultParticipationPoints(userSettings)
                                : question.participationWeightage;
                        }
                    }


                }
            } else {
                copy.audienceRestriction = getActivityAudienceRestriction({}, userSettings);
                copy.syncLms = false;
                delete copy.syncLmsOption;
                delete copy.courseId;
                delete copy.D2LModuleId;
                delete copy.moodleSectionId;
            }

            setAlertShow(false);
            setDraftActivity(copy);

            if (!isLMS() || chosenSchema === GRADE_SCHEMA.UNGRADED.key) {
                redirectEditingView();
            }
        },
        close:  () => setAlertShow(false),
    };


    const syncLmsAlertConfig = {
        title: "Update Grade Book Sync",
        okText: CONTINUE_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        submit: () => {
            const copy = JSON.parse(JSON.stringify(draftActivity));
            copy.syncLms = chosenSyncLms;

            if (copy.syncLms) {
                copy.audienceRestriction = AUDIENCE_RESTRICTION.REGISTERED;
            } else {
                copy.audienceRestriction = getActivityAudienceRestriction({}, userSettings);
                delete copy.syncLmsOption;
                delete copy.courseId;
                delete copy.D2LModuleId;
                delete copy.moodleSectionId;
            }


            if (copy.syncLms && !copy.syncLmsOption) {
                const {syncLmsOption, courseId} = getDefaultConfiguration(courseList);
                copy.syncLmsOption = syncLmsOption;
                copy.courseId = courseId;
            }

            setSyncLmsAlertShow(false);
            setDraftActivity(copy);

            if (!isLMS() || !chosenSyncLms) {
                redirectEditingView();
            }
        },
        close:  () => setSyncLmsAlertShow(false),
    };

    const shouldDisableOverviewConfiguration = (!!hasReleased || isAlreadyEmbedded());

    const renderLMSConfiguration = () => {


        if(!isLMS()) {
            return <></>;
        }

        if (pollType === POLL_TYPE.MERGED_POLL && (!gradeSchema || gradeSchema === GRADE_SCHEMA.UNGRADED.key)) {
            return <></>;
        }

        return (
            <>
                <CreateD2LModuleModal
                    show={createModuleModalShown}
                    setModalShow={setCreateModuleModalShown}
                    selectedCourseId={draftActivity.courseId}
                    saveSuccessCb={() => {
                        loadModulesAndGetDefaultId(draftActivity.courseId).then((moduleId) => {
                            let integrationType = getIntegrationType();
                            let propertyName = integrationType === INTEGRATION_TYPES.D2L ? "D2LModuleId" : "moodleSectionId";

                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            copy[propertyName] = moduleId;
                            setDraftActivity(copy);
                        });
                    }}
                />

                {pollType === POLL_TYPE.ATTENDANCE &&
                    <div style={{display: "flex", gap: 40}}>
                        <Button
                            disabled={shouldDisableOverviewConfiguration}
                            className={`
                                ${classes.gradeSchemaCard} 
                                ${syncLms === true ? classes.active : ""}
                                ${shouldDisableOverviewConfiguration ? classes.disabled : ""}
                            `}
                            onClick={(e) => chooseSyncGradeBook(true, e)}
                        >
                            <SYNC_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                            <span className={classes.title}>{"Sync with Grade Book"}</span>
                            <span className={classes.description} style={{textAlign: "center"}}>
                                {"Results will be synced to your LMS grade book."}
                            </span>
                        </Button>

                        <Button
                            disabled={shouldDisableOverviewConfiguration}
                            className={`
                                ${classes.gradeSchemaCard} 
                                ${syncLms === false ? classes.active : ""}
                                ${shouldDisableOverviewConfiguration ? classes.disabled : ""}
                            `}
                            onClick={(e) => chooseSyncGradeBook(false, e)}
                        >
                            <NOT_SYNC_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                            <span className={classes.title}>{"No Grade Book Sync"}</span>
                            <span className={classes.description} style={{textAlign: "center"}}>
                                {"Results will not be synced to your LMS grade book."}
                            </span>
                        </Button>
                    </div>
                }

                <div style={{position: "relative", display: "flex", flexDirection: "column", width: "100%", gap: 15, marginTop: 20}}>
                    {shouldDisableOverviewConfiguration &&
                        <div
                            style={{
                                position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                background: "#E6E6E6", opacity: 0.5,
                                cursor: "not-allowed", zIndex: 1
                            }}
                        />
                    }

                    {/*{!!syncLms && isAPISyncOptionAvailable() && syncLmsOption !== SYNC_LMS_OPTIONS.EMBEDDED &&*/}
                    {/*    <span className={settingClasses.settingDescription}>*/}
                    {/*        {"Required fields are marked with an asterisk"} <STAR_RED_ICON style={{marginLeft: 5}}/>*/}
                    {/*    </span>*/}
                    {/*}*/}


                    {pollType === POLL_TYPE.MERGED_POLL &&
                        <div className={settingClasses.settingRow}>
                            <div style={{flex: 1, minWidth: 0}}>
                            <div className={settingClasses.settingLabel} style={{display: "flex", alignItems: "center", gap: 5}}>
                                    {GRADE_BOOK_SYNC_TEXT} <STAR_RED_ICON/>
                                </div>
                                <div className={settingClasses.settingDescription}>
                                    {GRADE_BOOK_SYNC_DESCRIPTION}
                                </div>
                            </div>
                            <YuJaSwitch
                                aria-label={GRADE_BOOK_SYNC_TEXT}
                                checked={draftActivity.syncLms}
                                onChange={(checked, e) => chooseSyncGradeBook(!draftActivity.syncLms, e)}
                            />
                            {/*<YuJaToggle*/}
                            {/*    // disabled={isAlreadyEmbedded()}*/}
                            {/*    containerStyle={{flexShrink: 0}}*/}
                            {/*    name={"activityLmsSyncToggle"}*/}
                            {/*    toggled={draftActivity.syncLms}*/}
                            {/*    onClick={(e) => chooseSyncGradeBook(!draftActivity.syncLms, e)}*/}
                            {/*/>*/}
                        </div>
                    }

                    {!!syncLms && isAPISyncOptionAvailable() && syncLmsOption !== SYNC_LMS_OPTIONS.EMBEDDED &&
                        <div style={{display: "flex", flexDirection: "column", gap: 10}}>
                            <div className={settingClasses.settingRow}>
                                <div style={{flex: 1, minWidth: 0}}>
                                    <div className={settingClasses.settingLabel}
                                         style={{display: "flex", alignItems: "center", gap: 5}}>
                                        {COURSE_FILTER_LABEL} <STAR_RED_ICON/>
                                    </div>
                                    <div className={settingClasses.settingDescription}>
                                        {"Select a course to sync results to."}
                                    </div>
                                </div>
                                <YuJaDropdown
                                    placeholder={COURSE_PLACEHOLDER}
                                    // disabled={isAlreadyEmbedded()}
                                    searchAble={true}
                                    containerStyle={{flex: 1, minWidth: 200, maxWidth: 300}}
                                    size={"small"}
                                    data={courseList.filter(c => !!c.isLmsCourse)}
                                    value={courseId}
                                    onChange={async option => {
                                        const copy = JSON.parse(JSON.stringify(draftActivity));
                                        copy.courseId = option.value;
                                        setDraftActivity(copy);
                                    }}
                                />
                            </div>


                            {[INTEGRATION_TYPES.D2L, INTEGRATION_TYPES.MOODLE].includes(integrationType) && !!moduleDropdownLoading &&
                                <div className={settingClasses.settingRow}>
                                    <div style={{flex: 1, minWidth: 0}}>
                                        <div
                                            className={settingClasses.settingLabel}
                                            style={{display: "flex", alignItems: "center", gap: 5}}
                                        >
                                            {integrationType === INTEGRATION_TYPES.D2L ? MODULE_LABEL : SECTION_HEADER} <STAR_RED_ICON/>
                                        </div>
                                        <div className={settingClasses.settingDescription}>
                                            {integrationType === INTEGRATION_TYPES.D2L
                                                ? "Select a D2L Brightspace module."
                                                : "Select a Moodle section."
                                            }
                                        </div>
                                    </div>
                                    <span style={{flex: 1, minWidth: 200, maxWidth: 300, height: 55}}>
                                        <Skeleton
                                            highlightColor="lightgrey"
                                            width="100%"
                                            height="100%"
                                            borderRadius={4}
                                            style={{lineHeight: "unset"}}
                                        />
                                    </span>
                                </div>
                            }

                            {[INTEGRATION_TYPES.D2L, INTEGRATION_TYPES.MOODLE].includes(integrationType)
                                && !moduleDropdownLoading
                                && (!draftActivity.LMSColumnId || !!D2LModuleId || !!moodleSectionId)
                                &&
                                <>
                                    <div className={settingClasses.settingRow}>
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <div
                                                className={settingClasses.settingLabel}
                                                style={{display: "flex", alignItems: "center", gap: 5}}
                                            >
                                                {integrationType === INTEGRATION_TYPES.D2L ? MODULE_LABEL : SECTION_HEADER} <STAR_RED_ICON/>
                                            </div>
                                            <div className={settingClasses.settingDescription}>
                                                {integrationType === INTEGRATION_TYPES.D2L
                                                    ? "Select a D2L Brightspace module."
                                                    : "Select a Moodle section."
                                                }
                                            </div>
                                        </div>

                                        {!!moduleList.length &&
                                            <YuJaDropdown
                                                placeholder={
                                                    integrationType === INTEGRATION_TYPES.D2L
                                                        ? D2L_MODULE_PLACEHOLDER
                                                        : MOODLE_SECTION_PLACEHOLDER
                                                }
                                                // disabled={isAlreadyEmbedded()}
                                                searchAble={true}
                                                containerStyle={{flex: 1, minWidth: 200, maxWidth: 300}}
                                                size={"small"}
                                                data={moduleList}
                                                value={integrationType === INTEGRATION_TYPES.D2L ? D2LModuleId : moodleSectionId}
                                                onChange={option => {
                                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                                    if (integrationType === INTEGRATION_TYPES.D2L) {
                                                        copy.D2LModuleId = option.value;
                                                    } else {
                                                        copy.moodleSectionId = option.value;
                                                    }

                                                    setDraftActivity(copy);
                                                }}
                                            />
                                        }
                                    </div>
                                    {!moduleList.length &&
                                        <div className={classes.unfinishedEmbeddedNotification} style={{marginTop: 20}}>
                                            <SPEAKER_ICON style={{flexShrink: 0}}/>
                                            <span style={{flex: 1, minWidth: 150}}>
                                                {getIntegrationType() === INTEGRATION_TYPES.D2L
                                                    ? "The selected course does not have a module. Please create a module to continue."
                                                    :"The selected course does not have a section. Please create a section to continue."
                                                }
                                            </span>
                                            <YuJaButton
                                                style={{width: 150, height: 35, marginLeft: 5, flexShrink: 0}}
                                                onClick={() => setCreateModuleModalShown(true)}
                                            >
                                                {getIntegrationType() === INTEGRATION_TYPES.D2L ? CREATE_MODULE : CREATE_SECTION}
                                            </YuJaButton>
                                        </div>
                                    }
                                </>

                            }
                        </div>
                    }


                    {isUnfinishedEmbedded() &&
                        <div className={classes.unfinishedEmbeddedNotification} style={{marginTop: 20}}>
                            <SPEAKER_ICON style={{flexShrink: 0}}/>
                            <span>
                                {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                    ? EDITING_SYNC_LMS_EMBEDDED_BANNER_ATTENDANCE
                                    : EDITING_SYNC_LMS_EMBEDDED_BANNER
                                }
                                <Button className={classes.link} style={{marginLeft: 5}}
                                      onClick={onClickLearnMore}>
                                    {
                                        (draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                            ? EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE_ATTENDANCE
                                            : EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE)
                                        + LMS_TYPE[integrationType].name + "."
                                    }
                                </Button>
                            </span>
                        </div>
                    }
                </div>
            </>
        );

    }

    if (pollType === POLL_TYPE.ATTENDANCE) {
        return (
            <div className={classes.questionMainContainer} style={{alignItems: "center"}}>
                {/*<YuJaGeneralAlert*/}
                {/*    show={syncLmsAlertShow}*/}
                {/*    setModalShow={setSyncLmsAlertShow}*/}
                {/*    content={parse(EDITING_SYNC_LMS_SYNC_TO_NOT_SYNC_CONTENT)}*/}
                {/*    config={syncLmsAlertConfig}*/}
                {/*/>*/}
                <YuJaDialog
                    open={syncLmsAlertShow}
                    setOpen={setSyncLmsAlertShow}
                    title={syncLmsAlertConfig.title}
                    closeText={syncLmsAlertConfig.cancelText}
                    centerAligned={false}
                    onSubmit={() => syncLmsAlertConfig.submit()}
                    submitText={syncLmsAlertConfig.okText}
                >
                    <div>
                        {parse(EDITING_SYNC_LMS_SYNC_TO_NOT_SYNC_CONTENT)}
                    </div>
                </YuJaDialog>


                <div style={{height: 30, flexShrink: 1}}/>
                <div style={{alignSelf: "center", display: "flex", flexDirection: "column", width: "min(700px, 100%)"}}>
                    <div style={{alignSelf: "center", display: "flex", gap: 15, alignItems: "center", marginBottom: 35}}>
                        <span className={classes.plusIconWrapper}><GRADE_BOOK_ICON/></span>
                        <span className={classes.title}>
                            {"Would you like to sync the attendance results with the LMS grade book?"}
                        </span>
                    </div>

                    {shouldDisableOverviewConfiguration &&
                        <div className={classes.disabledNotification}>
                            <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                            <span>
                                <span className={classes.title} style={{marginRight: 5}}>
                                    {"Editing Disabled:"}
                                </span>
                                <span>
                                     {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                         ? (hasReleased
                                                 ? "Grade Options cannot be edited once you release the attendance."
                                                 : "Grade Options cannot be edited once you embed the attendance."
                                         )
                                         : (hasReleased
                                                 ? "Grade Options cannot be edited once you release the poll."
                                                 : "Grade Options cannot be edited once you embed the poll."
                                         )
                                     }
                                </span>
                            </span>
                        </div>
                    }
                    {renderLMSConfiguration()}
                </div>

                {/*isLMS() && !!gradeSchema && !verifyConfiguration(draftActivity) && !hasClicked &&*/}
                {isLMS() && !verifyConfiguration(draftActivity) && !hasClicked &&
                    <YuJaButton
                        onClick={() => {
                            setEditorView(ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
                            setHasClicked(true);
                        }}
                    >
                        {"Add a Question"}
                    </YuJaButton>
                }
            </div>
        );
    }


    return (
        <div className={classes.questionMainContainer} style={{alignItems: "center"}}>
            <YuJaDialog
                open={alertShow}
                setOpen={setAlertShow}
                title={alertConfig.title}
                closeText={alertConfig.cancelText}
                centerAligned={false}
                onSubmit={() => alertConfig.submit()}
                submitText={alertConfig.okText}
                // style={{maxHeight: 725, width: "min(420px, calc(100vw - 2rem))"}}

            >
                { isAPISyncOptionAvailable()
                    ? EDITING_GRADING_OPTION_GRADED_TO_UNGRADED_CONTENT_LMS
                    : EDITING_GRADING_OPTION_GRADED_TO_UNGRADED_CONTENT}
            </YuJaDialog>


            <YuJaDialog
                open={syncLmsAlertShow}
                setOpen={setSyncLmsAlertShow}
                title={syncLmsAlertConfig.title}
                closeText={syncLmsAlertConfig.cancelText}
                centerAligned={false}
                onSubmit={() => syncLmsAlertConfig.submit()}
                submitText={syncLmsAlertConfig.okText}
            >
                <div>
                    {parse(EDITING_SYNC_LMS_SYNC_TO_NOT_SYNC_CONTENT)}
                </div>
            </YuJaDialog>




            {/*<YuJaGeneralAlert*/}
            {/*    show={syncLmsAlertShow}*/}
            {/*    setModalShow={setSyncLmsAlertShow}*/}
            {/*    content={parse(EDITING_SYNC_LMS_SYNC_TO_NOT_SYNC_CONTENT)}*/}
            {/*    config={syncLmsAlertConfig}*/}
            {/*    */}
            {/*/>*/}

            <div style={{height: 30, flexShrink: 1}}/>
            <div style={{alignSelf: "center", display: "flex", flexDirection: "column", width: "min(700px, 100%)"}}>
                <div style={{alignSelf: "center", display: "flex", gap: 15, alignItems: "center", marginBottom: 35}}>
                    <span className={classes.plusIconWrapper}><GRADE_BOOK_ICON/></span>
                    <span className={classes.title}>{CHOOSE_GRADE_SCHEMA_ASKING}</span>
                </div>

                {shouldDisableOverviewConfiguration &&
                    <div className={classes.disabledNotification}>
                        <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                        <span>
                                <span className={classes.title} style={{marginRight: 5}}>
                                    {"Editing Disabled:"}
                                </span>
                                <span>
                                    {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                        ? (hasReleased
                                                ? "Grade Options cannot be edited once you release the attendance."
                                                : "Grade Options cannot be edited once you embed the attendance."
                                        )
                                        : (hasReleased
                                                ? "Grade Options cannot be edited once you release the poll."
                                                : "Grade Options cannot be edited once you embed the poll."
                                        )
                                    }
                                </span>
                            </span>
                    </div>
                }
                <div style={{display: "flex", gap: 40}}>
                    {Object.values(GRADE_SCHEMA).map((schema, index) => {
                        const {key, name, description, image: SchemaImage} = schema;
                        return (
                            <Button
                                key={index}
                                disabled={shouldDisableOverviewConfiguration}
                                className={`
                                    ${classes.gradeSchemaCard} 
                                    ${gradeSchema === key ? classes.active : ""}
                                    ${shouldDisableOverviewConfiguration ? classes.disabled : ""}
                                `}
                                onClick={(e) => chooseGradeSchema(key, e)}
                            >
                                <SchemaImage style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title}>{name}</span>
                                <span className={classes.description} style={{textAlign: "center"}}>{description}</span>
                            </Button>
                        );
                    })}
                </div>
                {renderLMSConfiguration()}
            </div>

            {isLMS() && !!gradeSchema && !verifyConfiguration(draftActivity) && !hasClicked &&
                <YuJaButton
                    onClick={() => {
                        setEditorView( ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
                        setHasClicked(true);
                    }}
                >
                    {"Start Adding Questions"}
                </YuJaButton>
            }

        </div>
    );
}